export default "__VITE_ASSET__cdab55ae__"